import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const SettingsActions = createActionGroup({
  source: 'Settings',
  events: {
    'Load Profile Image': emptyProps(),
    'Set Profile Image Url': props<{ url: string }>(),
    'Upload Profile Image': props<{ file: File; previewUrl: string }>(),
    'Upload Profile Image Success': props<{ url: string }>(),
    'Upload Profile Image Failure': props<{ error: string }>(),
  },
});
